import clsx from "clsx";
import TextInput from "../TextInput/TextInput";
import React, { useRef } from "react";
import {
  MdBackspace,
  MdOutlineBackspace,
  MdOutlineClear,
  MdOutlineSearch,
} from "react-icons/md";
import { ICON_SIZES } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { EButtonKind } from "../Button/ButtonTypes";

interface ITableQuickFilter {
  onChange: (data: any) => void;
  searchTerm: string;
}

const TableQuickFilter: React.FC<ITableQuickFilter> = ({
  onChange,
  searchTerm,
}) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={clsx(["flex", "gap-2", "flex-row", "items-center", "w-full"])}
    >
      <MdOutlineSearch
        size={ICON_SIZES.MD}
        className={clsx([
          "shrink-0",
          "cursor-pointer",
          {
            "dark:text-purple-500 text-red-500": searchTerm,
          },
        ])}
        onClick={() => {
          if (inputRef?.current) {
            inputRef?.current?.focus?.();
            inputRef?.current?.select?.();
          }
        }}
      />
      <TextInput
        value={searchTerm}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder={t("shared.quick_search")}
        className="flex-grow"
        ref={inputRef}
      />
      <ButtonGroup
        buttons={[
          {
            icon: <MdBackspace size={ICON_SIZES.MD} />,
            onClick: () => onChange(""),
            disabled: !searchTerm,
            tooltip: "Restablecer",
            kind: searchTerm ? EButtonKind.DANGER : EButtonKind.NORMAL,
          },
        ]}
        align="right"
      />
    </div>
  );
};

export default TableQuickFilter;
